var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0125 15.0975C9.44249 15.615 8.56499 15.615 7.99499 15.09L7.91249 15.015C3.97499 11.4525 1.40249 9.12 1.49999 6.21C1.54499 4.935 2.19749 3.7125 3.25499 2.9925C5.23499 1.6425 7.67999 2.2725 8.99999 3.8175C10.32 2.2725 12.765 1.635 14.745 2.9925C15.8025 3.7125 16.455 4.935 16.5 6.21C16.605 9.12 14.025 11.4525 10.0875 15.03L10.0125 15.0975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.270b4f954961f9e1b444555c4dd0a7cc.svg";
export { ForwardRef as ReactComponent };